import Login from "../Components/Login";
import Home from "../Components/Home";
import Cursos from "../Components/Cursos";
import Trilha from "../Components/Trilha";
import Curso from "../Components/Curso";
import Jogos from "../Components/Jogos";
import Cadastros from "../Components/Cadastros";
import Error from "../Components/Error";
import NovaSenha from "../Components/NovaSenha";
import Logout from "../Components/Logout";
import EditarCadastro from "../Components/EditarCadastro";
import ClassForm from "../Components/Cadastros/Turmas/ClassForm";
import CursoConcluido from "../Components/CursoConcluido";
import TrilhaConcluida from "../Components/TrilhaConcluida";
import Relatorios from "../Components/Relatorios";
import LoginPlaymove from "../Components/LoginPlaymove";
import AcessoPlataformas from "../Components/LoginPlaymove/AcessoPlataformas";
import LoginFromToken from "../Components/LoginPlaymove/LoginFromToken";
import CriarSenhaPlaymove from "../Components/CriarSenhaPlaymove";
import { classUrl } from "../Configs";

export const ROUTE_KEYS = Object.freeze({
    LOGIN: "login",
    LOGIN_PLAYMOVE: "loginPlaymove",
    PLATFORM_ACCESS: "platformAccess",
    CREATE_PLAYMOVE_PASSWORD: "createPlaymovePassword",
    LOGIN_FROM_TOKEN: "loginFromToken",
    LOGOUT: "logout",
    RESET_PASSWORD: "resetPassword",
    HOME: "home",
    COURSES: "courses",
    EDIT_PROFILE: "editProfile",
    COURSE_DETAILS: "courseDetails",
    COURSE_COMPLETED: "courseCompleted",
    TRAIL_DETAILS: "trailDetails",
    TRAIL_COMPLETED: "trailCompleted",
    GAMES: "games",
    REGISTRATIONS_HOME: "registrationsHome",
    REGISTRATIONS_CLASSES: "registrationsClasses",
    REGISTRATIONS_CLASS_EDIT: "registrationsClassEdit",
    REGISTRATIONS_CLASS_CREATE: "registrationsClassCreate",
    REGISTRATIONS_STUDENTS: "registrationsStudents",
    REPORTS_HOME: "reportsHome",
    REPORTS_COURSE_PROGRESS: "reportsCourseProgress",
    ERROR_404: "error404",
    ERROR_500: "error500"
});

export const SUPPORTED_LANGUAGES = ["pt-BR", "en-CA", "en-US"];
export const FALLBACK_LANGUAGE = "pt-BR";

function cloneConfig(config) {
    if (config === undefined || config === null || typeof config === "string") {
        return config;
    }

    const {primary, aliases = [], ...rest} = config;
    return {
        ...rest,
        primary,
        aliases: Array.isArray(aliases) ? [...aliases] : []
    };
}

function buildLocalizedPaths(configByLocale) {
    const localized = {};

    Object.entries(configByLocale).forEach(([locale, config]) => {
        if (!config) {
            return;
        }
        localized[locale] = cloneConfig(config);
    });

    if (localized["en-CA"] && !localized["en-US"]) {
        localized["en-US"] = cloneConfig(localized["en-CA"]);
    } else if (localized["en-US"] && !localized["en-CA"]) {
        localized["en-CA"] = cloneConfig(localized["en-US"]);
    }

    return localized;
}

const routes = [
    {
        key: ROUTE_KEYS.LOGIN,
        getElement: () => <Login/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/entrar", aliases: ["/", "/login"]},
            "en-CA": {primary: "/login", aliases: ["/", "/sign-in"]}
        })
    },
    {
        key: ROUTE_KEYS.LOGIN_PLAYMOVE,
        getElement: () => <LoginPlaymove/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/acesso-playmove", aliases: ["/loginPlaymove"]},
            "en-CA": {primary: "/access", aliases: ["/login-playmove", "/loginPlaymove"]}
        })
    },
    {
        key: ROUTE_KEYS.PLATFORM_ACCESS,
        getElement: () => <AcessoPlataformas/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/acesso-plataformas", aliases: ["/acessoPlataformas"]},
            "en-CA": {primary: "/platform-access", aliases: []}
        })
    },
    {
        key: ROUTE_KEYS.CREATE_PLAYMOVE_PASSWORD,
        getElement: () => <CriarSenhaPlaymove/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {
                primary: "/criar-senha-playmove/:forgotPasswordToken",
                aliases: ["/criarSenhaPlaymove/:forgotPasswordToken"]
            },
            "en-CA": {
                primary: "/create-playmove-password/:forgotPasswordToken",
                aliases: ["/createPlaymovePassword/:forgotPasswordToken"]
            }
        })
    },
    {
        key: ROUTE_KEYS.LOGIN_FROM_TOKEN,
        getElement: () => <LoginFromToken/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/login-por-token", aliases: ["/loginFromToken"]},
            "en-CA": {primary: "/login-from-token", aliases: ["/loginFromToken"]}
        })
    },
    {
        key: ROUTE_KEYS.LOGOUT,
        getElement: () => <Logout/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/sair", aliases: ["/logout"]},
            "en-CA": {primary: "/logout", aliases: ["/sign-out"]}
        })
    },
    {
        key: ROUTE_KEYS.RESET_PASSWORD,
        getElement: () => <NovaSenha/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {
                primary: "/nova-senha/:forgotPasswordToken",
                aliases: ["/novasenha/:forgotPasswordToken"]
            },
            "en-CA": {
                primary: "/new-password/:forgotPasswordToken",
                aliases: ["/reset-password/:forgotPasswordToken"]
            }
        })
    },
    {
        key: ROUTE_KEYS.HOME,
        getElement: () => <Home/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/inicio", aliases: ["/home"]},
            "en-CA": {primary: "/home", aliases: ["/dashboard"]}
        })
    },
    {
        key: ROUTE_KEYS.COURSES,
        getElement: () => <Cursos/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/cursos", aliases: []},
            "en-CA": {primary: "/courses", aliases: []}
        })
    },
    {
        key: ROUTE_KEYS.EDIT_PROFILE,
        getElement: () => <EditarCadastro/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/editar-cadastro", aliases: []},
            "en-CA": {primary: "/edit-profile", aliases: []}
        })
    },
    {
        key: ROUTE_KEYS.COURSE_DETAILS,
        getElement: () => <Curso/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/cursos/:id", aliases: []},
            "en-CA": {primary: "/courses/:id", aliases: []}
        })
    },
    {
        key: ROUTE_KEYS.COURSE_COMPLETED,
        getElement: () => <CursoConcluido/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/cursos/:id/concluido", aliases: []},
            "en-CA": {primary: "/courses/:id/completed", aliases: []}
        })
    },
    {
        key: ROUTE_KEYS.TRAIL_DETAILS,
        getElement: () => <Trilha/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/trilhas/:id", aliases: []},
            "en-CA": {primary: "/learning-paths/:id", aliases: ["/trails/:id"]}
        })
    },
    {
        key: ROUTE_KEYS.TRAIL_COMPLETED,
        getElement: () => <TrilhaConcluida/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/trilhas/:id/concluido", aliases: []},
            "en-CA": {primary: "/learning-paths/:id/completed", aliases: ["/trails/:id/completed"]}
        })
    },
    {
        key: ROUTE_KEYS.GAMES,
        getElement: () => <Jogos/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/jogos", aliases: []},
            "en-CA": {primary: "/games", aliases: []}
        })
    },
    {
        key: ROUTE_KEYS.REGISTRATIONS_HOME,
        getElement: () => <Cadastros section="schools"/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/cadastros", aliases: ["/cadastros/escolas"]},
            "en-CA": {primary: "/registrations", aliases: ["/registrations/schools"]}
        }),
        matchOptions: {end: false}
    },
    {
        key: ROUTE_KEYS.REGISTRATIONS_CLASSES,
        getElement: () => <Cadastros section="classes"/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/cadastros/turmas", aliases: []},
            "en-CA": {primary: "/registrations/classes", aliases: []}
        })
    },
    {
        key: ROUTE_KEYS.REGISTRATIONS_CLASS_EDIT,
        getElement: () => <ClassForm edit/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/cadastros/turmas/:id", aliases: []},
            "en-CA": {primary: "/registrations/classes/:id", aliases: []}
        })
    },
    {
        key: ROUTE_KEYS.REGISTRATIONS_CLASS_CREATE,
        getElement: () => <ClassForm/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/cadastros/turmas/nova", aliases: []},
            "en-CA": {primary: "/registrations/classes/new", aliases: []}
        })
    },
    {
        key: ROUTE_KEYS.REGISTRATIONS_STUDENTS,
        getElement: () => <Cadastros section="students"/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/cadastros/alunos", aliases: []},
            "en-CA": {primary: "/registrations/students", aliases: []}
        })
    },
    {
        key: ROUTE_KEYS.REPORTS_HOME,
        getElement: () => <Relatorios section="Progresso por Curso"/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/relatorios", aliases: []},
            "en-CA": {primary: "/reports", aliases: []}
        }),
        matchOptions: {end: false}
    },
    {
        key: ROUTE_KEYS.REPORTS_COURSE_PROGRESS,
        getElement: () => <Relatorios section="Progresso por Curso"/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {
                primary: "/relatorios/progressos-cursos",
                aliases: ["/relatorios/progressosCursos"]
            },
            "en-CA": {primary: "/reports/course-progress", aliases: []}
        })
    },
    {
        key: ROUTE_KEYS.ERROR_404,
        getElement: () => <Error type="404"/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/erro-404", aliases: ["/error404"]},
            "en-CA": {primary: "/error404", aliases: ["/404"]}
        })
    },
    {
        key: ROUTE_KEYS.ERROR_500,
        getElement: () => <Error type="500"/>,
        localizedPaths: buildLocalizedPaths({
            "pt-BR": {primary: "/erro-500", aliases: ["/error500"]},
            "en-CA": {primary: "/error500", aliases: ["/500"]}
        })
    }
];

const LANGUAGE_NORMALIZERS = [
    {test: (lang) => lang?.toLowerCase().startsWith("pt"), normalized: "pt-BR"},
    {test: (lang) => lang?.toLowerCase().startsWith("en-ca"), normalized: "en-CA"},
    {test: (lang) => lang?.toLowerCase().startsWith("en-us"), normalized: "en-US"},
    {test: (lang) => lang?.toLowerCase().startsWith("en"), normalized: "en-CA"}
];

function normalizeLanguage(language) {
    const normalizer = LANGUAGE_NORMALIZERS.find(({test}) => test(language));
    if (normalizer) {
        return normalizer.normalized;
    }
    return FALLBACK_LANGUAGE;
}

function ensureRoute(routeKey) {
    const route = routes.find((entry) => entry.key === routeKey);
    if (!route) {
        throw new Error(`Route with key "${routeKey}" was not found.`);
    }
    return route;
}

function flattenLocalizedPaths(localizedPaths) {
    const uniquePaths = new Set();
    Object.values(localizedPaths || {}).forEach((config) => {
        if (!config) {
            return;
        }

        if (typeof config === "string") {
            uniquePaths.add(config);
            return;
        }

        const {primary, aliases = []} = config;
        if (primary) {
            uniquePaths.add(primary);
        }
        aliases.forEach((alias) => uniquePaths.add(alias));
    });

    return Array.from(uniquePaths);
}

function populateParams(pathTemplate, params = {}) {
    return pathTemplate.replace(/:([A-Za-z0-9_]+)/g, (match, key) => {
        if (!(key in params)) {
            throw new Error(`Missing parameter "${key}" for path "${pathTemplate}".`);
        }
        return params[key];
    });
}

function getClassLoginUrl() {
    const normalizedClassUrl = (classUrl || "https://class.playmove.com.br").replace(/\/+$/, "");
    return `${normalizedClassUrl}/login`;
}

export function getRoutes() {
    return routes;
}

export function getExternalRedirects() {
    const classLoginUrl = getClassLoginUrl();
    return [
        {path: "/loginPlaymove", url: classLoginUrl},
        {path: "/acesso-plataformas", url: classLoginUrl}
    ];
}

export function getRouteMatchOptions(routeKey) {
    return ensureRoute(routeKey).matchOptions ?? {end: true};
}

export function getAllPathsForRouteKey(routeKey) {
    const route = ensureRoute(routeKey);
    return flattenLocalizedPaths(route.localizedPaths);
}

export function getLocalizedRoutePath(routeKey, language, params = {}) {
    const route = ensureRoute(routeKey);
    const normalizedLanguage = normalizeLanguage(language);
    const langConfig =
        route.localizedPaths[normalizedLanguage] ??
        route.localizedPaths[FALLBACK_LANGUAGE] ??
        Object.values(route.localizedPaths)[0];

    if (!langConfig) {
        throw new Error(`No localized paths defined for route "${routeKey}".`);
    }

    const template =
        typeof langConfig === "string"
            ? langConfig
            : langConfig.primary ?? langConfig.aliases?.[0];

    if (!template) {
        throw new Error(`No template path found for route "${routeKey}".`);
    }

    return populateParams(template, params);
}
